import { FEATURES } from '@constants/Text'
import { registrar } from '@modules/aawz-intelligence-v2/ui-registry'
import * as atendimentoStore from './store'
import registryAtendimento from './ia/registry'

/**
 * Ponto de entrada do módulo — chamado por `src/modules/index.js` no boot,
 * antes de qualquer rota renderizar.
 *
 * Duas coisas acontecem aqui, e as duas são "ligar o módulo à aplicação": o
 * store namespaced e, desde a spec-010 do `plataforma-por-chat` ([T017]), o
 * registry PARCIAL dos três cartões deste módulo.
 *
 * ★ Aqui, e não numa view: o cartão pode chegar em QUALQUER conversa (a do
 * CRM, a do Especialista, o chat do intelligence-v2), e registrar na view
 * deixaria o mesmo `tool_result` virar cartão numa tela e `fallback-card` na
 * outra. `registerAllModules` roda uma vez, no boot, antes de qualquer thread
 * montar.
 *
 * ★ A guarda de reentrada cobre os DOIS registros. `registrar` recusa chave
 * repetida por desenho (override silencioso entre módulos é bug), então uma
 * segunda chamada desta função estouraria nela — e o `hasModule` que já
 * protegia o store passa a proteger o registry pelo mesmo caminho.
 */
export function atendimentoModule({ store }) {
  if (typeof store.hasModule === 'function' && store.hasModule('atendimento')) {
    return
  }

  store.registerModule('atendimento', {
    ...atendimentoStore,
    namespaced: true,
  })

  registrar(registryAtendimento)
}

export const PERMISSION = FEATURES.ATENDIMENTO
